// extracted by mini-css-extract-plugin
export default {"form":"createCategory_form__FuOds","formInputBlock":"createCategory_formInputBlock__FM-eP","formInput":"createCategory_formInput__KdGMj"};